import angular from 'angular';

export class PassthroughModel {
    /**
     * @param {Object} initializer to initialize the Model.
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        angular.extend(this, init);
    }

    serialize() {
        let serialized = {};
        angular.extend(serialized, this);
        return serialized;
    }
}

export class PassthroughService {
    /**
     * create a new PassthroughModel instance.
     * @param {Object} defaults - pojo (deserialized version) of a PassthroughModel to initialize state.
     */
    newModel(defaults) {
        return new PassthroughModel(defaults);
    }
}


// WEBPACK FOOTER //
// ./app/jangl/PassthroughService.js